import MiniCartItem from 'snippets/mini-cart-item/mini-cart-item'

function MiniCartList({ items, setCart, isFetching, setIsFetching }) {
  return (
    <div className="flex flex-col px-4 md:px-6">
      {items.map((cartItem) => (
        <MiniCartItem key={cartItem.key} item={cartItem} setCart={setCart} isFetching={isFetching} setIsFetching={setIsFetching} />
      ))}
    </div>
  )
}

export default MiniCartList
